import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import type { AGUCrumbItem } from './crumb.labels';

/**
 * The trail the view on screen is showing, for the chrome that stands in for the crumb on a phone: the app bar's back chevron and
 * title read the first ancestor (P/Member_Hub.html:862-868), while the crumb itself is hidden there (:493).
 *
 * Provided by each surface component (like `AGUViewportService`), never `providedIn: 'root'`, so two surfaces never share a trail.
 * A view publishes its trail when it shows and `[]` when it leaves. Consumers paint from `Current$`; on this zoneless host a
 * consumer asks `AGURenderService.Notify()` for its repaint.
 */
@Injectable()
export class AGUCrumbService implements OnDestroy {
    private readonly current = new BehaviorSubject<readonly AGUCrumbItem[]>([]);

    /** The latest published trail; replays it to each new subscriber. */
    readonly Current$: Observable<readonly AGUCrumbItem[]> = this.current.asObservable();

    Publish(trail: readonly AGUCrumbItem[]): void {
        this.current.next(trail);
    }

    ngOnDestroy(): void {
        this.current.complete();
    }
}
